'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useRef, } from 'react';
import TimeAgo from 'javascript-time-ago';
const DateTimesContext = createContext(null);
const DateTimesProvider = ({ children, timeAgoLocale }) => {
    const timeAgo = useRef((() => {
        TimeAgo.addLocale(timeAgoLocale);
        return new TimeAgo(timeAgoLocale.locale);
    })());
    const timeSince = useCallback((value) => timeAgo.current.format(value, 'mini'), []);
    const value = useMemo(() => ({ timeSince }), [timeSince]);
    return (_jsx(DateTimesContext.Provider, { value: value, children: children }));
};
function useDateTimes() {
    const context = useContext(DateTimesContext);
    if (!context)
        throw new Error('useDateTimes requires a context!');
    return context;
}
export { DateTimesProvider, useDateTimes };
//# sourceMappingURL=dateTimes.js.map